module.exports = __webpack_public_path__ + "img/banner.279b250b.png";